class PredictiveSearch extends HTMLElement {
    constructor() {
        super();
        this.modal = this.closest('.search-modal');
        this.cachedResults = {};
        const perPage = this.dataset.perPage || 5;
        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
        this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
        this.isOpen = !1;
        this.searchTerm = '';
        this.setupEventListeners()
    }
    setupEventListeners() {
        this.querySelector('form.search').addEventListener('submit', this.onFormSubmit.bind(this));
        // this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));
        this.querySelector('button[type="reset"]').addEventListener('click', this.clear.bind(this));
        this.input.addEventListener('input', debounce((event) => {
            this.onChange(event)
        }, 300).bind(this));
        this.input.addEventListener('focus', this.onFocus.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.addEventListener('keyup', this.onKeyup.bind(this));
        this.addEventListener('keydown', this.onKeydown.bind(this))
    }
    getQuery() {
        return this.input.value.trim()
    }
    onChange() {
        const newSearchTerm = this.getQuery();
        if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
            this.querySelector("#predictive-search-results-groups-wrapper")?.remove()
        }
        this.updateSearchForTerm(this.searchTerm, newSearchTerm);
        this.searchTerm = newSearchTerm;
        if (!this.searchTerm.length) {
            this.clear();
            this.close(!0);
            return
        }
        this.getSearchResults(this.searchTerm)
    }
    onFormSubmit(event) {
        if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
    }
    onFocus() {
        // document.body.classList.add('predictive-search--focus');
        const currentSearchTerm = this.getQuery();
        if (!currentSearchTerm.length) return;
        if (this.searchTerm !== currentSearchTerm) {
            this.onChange()
        } else if (this.getAttribute('results') === 'true') {
            this.open()
        } else {
            this.getSearchResults(this.searchTerm)
        }
    }
    onFocusOut() {
        setTimeout(() => {
            if (!this.contains(document.activeElement)) this.close();
        })
    }
    onKeyup(event) {
        if (!this.getQuery().length) {
            this.clear(event);
            this.close(!0)
        }
        event.preventDefault();
        switch (event.code) {
            case 'ArrowUp':
                this.switchOption('up')
                break;
            case 'ArrowDown':
                this.switchOption('down');
                break;
            case 'Enter':
                this.selectOption();
                break
        }
    }
    onKeydown(event) {
        if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
            event.preventDefault()
        }
    }
    updateSearchForTerm(previousTerm, newTerm) {
        const searchForTextElement = this.querySelector("[data-predictive-search-search-for-text]");
        const currentButtonText = searchForTextElement?.innerText;
        if (currentButtonText) {
            const newButtonText = currentButtonText.replace(previousTerm, newTerm);
            searchForTextElement.innerText = newButtonText
        }
    }
    switchOption(direction) {
        if (!this.getAttribute('open')) return;
        const moveUp = direction === 'up';
        const selectedElement = this.querySelector('[aria-selected="true"]');
        const allElements = this.querySelectorAll('li');
        let activeElement = this.querySelector('li');
        if (moveUp && !selectedElement) return;
        this.statusElement.textContent = '';
        if (!moveUp && selectedElement) {
            activeElement = selectedElement.nextElementSibling || allElements[0]
        } else if (moveUp) {
            activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1]
        }
        if (activeElement === selectedElement) return;
        activeElement.setAttribute('aria-selected', !0);
        if (selectedElement) selectedElement.setAttribute('aria-selected', !1);
        this.setLiveRegionText(activeElement.textContent);
        this.input.setAttribute('aria-activedescendant', activeElement.id)
    }
    selectOption() {
        const selectedProduct = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');
        if (selectedProduct) selectedProduct.click();
    }
    getSearchResults(searchTerm) {
        const queryKey = searchTerm.replace(" ", "-").toLowerCase();
        const perPage = this.dataset.perPage || 4;
        this.setLiveRegionLoadingState();
        if (this.cachedResults[queryKey]) {
            this.renderSearchResults(this.cachedResults[queryKey]);
            if (this.modal) this.modal.classList.add('searching');
            return
        }
        // fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[limit]')}=${perPage}&${encodeURIComponent('resources[limit_scope]')}=each&section_id=predictive-search`)
fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[limit]')}=${perPage}&${encodeURIComponent('resources[limit_scope]')}=each&${encodeURIComponent('resources[options][fields]')}=${encodeURIComponent('title,product_type,variants.title,vendor,variants.sku')}&section_id=predictive-search`).then((response) => {
            if (!response.ok) {
                var error = new Error(response.status);
                this.close();
                throw error
            }
            return response.text()
        }).then((text) => {
            const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
            this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
                predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup
            });
            this.renderSearchResults(resultsMarkup);
            if (this.modal) this.modal.classList.add('searching');
        }).catch((error) => {
            if (error?.code === 20) {
                return
            }
            this.close();
            throw error
        })
    }
    setLiveRegionLoadingState() {
        this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
        this.loadingText = this.loadingText || this.getAttribute('data-loading-text');
        this.setLiveRegionText(this.loadingText);
        this.setAttribute('loading', !0)
    }
    setLiveRegionText(statusText) {
        this.statusElement.setAttribute('aria-hidden', 'false');
        this.statusElement.textContent = statusText;
        setTimeout(() => {
            this.statusElement.setAttribute('aria-hidden', 'true')
        }, 1000)
    }
    renderSearchResults(resultsMarkup) {
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.setAttribute('results', !0);
        this.setLiveRegionResults();
        this.open()
    }
    setLiveRegionResults() {
        this.removeAttribute('loading');
        this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent)
    }
    getResultsMaxHeight() {
        this.resultsMaxHeight = window.innerHeight - document.querySelector('.header').getBoundingClientRect().bottom;
        return this.resultsMaxHeight
    }
    open() {
        this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
        this.setAttribute('open', !0);
        this.input.setAttribute('aria-expanded', !0);
        this.isOpen = !0;
        // document.body.classList.add('predictive-search--focus')
    }
    close(clearSearchTerm = !1) {
        this.closeResults(clearSearchTerm);
        this.isOpen = !1
    }
    closeResults(clearSearchTerm = !1) {
        if (clearSearchTerm) {
            this.input.value = '';
            this.removeAttribute('results')
        }
        const selected = this.querySelector('[aria-selected="true"]');
        if (selected) selected.setAttribute('aria-selected', !1);
        this.input.setAttribute('aria-activedescendant', '');
        this.removeAttribute('loading');
        this.removeAttribute('open');
        this.input.setAttribute('aria-expanded', !1);
        // document.body.classList.remove('predictive-search--focus')
    }
    clear(event) {
        event.preventDefault();
        this.input.value = '';
        this.predictiveSearchResults.innerHTML = ''
        this.removeAttribute('open');
        this.removeAttribute('results');
        this.input.focus();
        if (this.modal) this.modal.classList.remove('searching');
    }
}
customElements.define('predictive-search', PredictiveSearch)